module.exports = __webpack_public_path__ + "4d882315cfb0f5da3ebac4517559cb33.png";